<template>
  <div
    class="inline-flex items-center my-2.5"
    :class="[
      phaseData.id === VICE_SESSION_PHASES.CONSULTATION
        ? 'mx-2.5 step-phase-consultation'
        : phaseData.id === VICE_SESSION_PHASES.INTRODUCTION
        ? 'step-phase-introduction'
        : 'step-phase-debrief',
    ]"
  >
    <span
      class="block h-px w-7 bg-white"
      v-if="phaseData.id !== VICE_SESSION_PHASES.INTRODUCTION"
    ></span>
    <span
      class="
        inline-flex
        justify-center
        items-center
        prose-sm
        font-bold
        w-10.5
        h-10.5
        mr-2
        border-2
        rounded-full
      "
    >
      {{ phaseData.id }}
    </span>
    <span class="text-sm font-medium leading-5">{{ phaseData.title }}</span>
  </div>
</template>

<script>
import { VICE_SESSION_PHASES } from '../../../Utils/vice-constants';

export default {
  props: {
    phaseData: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return { VICE_SESSION_PHASES };
  },
};
</script>

<style lang="scss" scoped></style>
